module.exports = __webpack_public_path__ + "static/colouring_in_kerry-e221626a5f5d56be8c57b3513ddd5c02.pdf";